import { Box, CircularProgress, Typography } from '@material-ui/core';

export function AnswerKeyLoading() {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gridGap={16} minHeight={200}>
      <CircularProgress />
      <Typography variant="body2" color="textSecondary">Carregando gabarito</Typography>
    </Box>
  );
}
